export default __webpack_public_path__ + "static/DedicatedTeams-1835db043eabdea20ef2aaac15768faa.svg";